import { render, staticRenderFns } from "./QuizScore.vue?vue&type=template&id=23772963&"
import script from "./QuizScore.vue?vue&type=script&lang=js&"
export * from "./QuizScore.vue?vue&type=script&lang=js&"
import style0 from "./QuizScore.vue?vue&type=style&index=0&id=23772963&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports